/** RevenueCat entitlement that unlocks Florafolio Pro. */
export const FLORAFOLIO_PRO_ENTITLEMENT = "Florafolio Pro";

/** Current offering lookup key in the RevenueCat dashboard. */
export const FLORAFOLIO_DEFAULT_OFFERING = "default";

/** Store product identifier for the US$7.99/month Pro plan. */
export const FLORAFOLIO_MONTHLY_PRODUCT_ID = "florafolio_pro_monthly";
